var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/UserClassifierRepo/DependencyWithModels.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { BaseClassifier } from '../BaseClassifierRepo';
import { BimModel } from '../BimEntity';
import { ApiDomain } from '../domain';
import { AnonymousClassifier } from '../AnonymousClassifier';
import { UserClassifier } from './UserClassifier';
import { AssemblyClassifier } from './AssemblyClassifier';
export var DependencyWithModels;

(function (_DependencyWithModels) {
  var domain = ApiDomain.domain('DependencyWithModels', {
    name: "domain",
    sid: "-l7x78e"
  });
  var io = _DependencyWithModels.io = t.recursion('DependencyWithModels', function () {
    return t.type({
      classifier: t.union([UserClassifier.io, BaseClassifier.io, AssemblyClassifier.io, AnonymousClassifier.io]),
      models: t.readonlyArray(t.union([BimModel.io, BimModel.NotLoaded.io]))
    });
  });
  var DependencyWithModelsResponse = _DependencyWithModels.DependencyWithModelsResponse = t.type({
    dependencyModels: t.array(DependencyWithModels.io)
  }, 'DependencyWithModelsResponse');
  var getClassifierDependencyModels = _DependencyWithModels.getClassifierDependencyModels = ApiCallService.create({
    name: 'getClassifierDependencyModels',
    parentDomain: domain,
    result: DependencyWithModelsResponse,
    getKey: ['id', 'version']
  });
  var getAssemblyDependencyModels = _DependencyWithModels.getAssemblyDependencyModels = ApiCallService.create({
    name: 'getAssemblyDependencyModels',
    parentDomain: domain,
    result: DependencyWithModelsResponse,
    getKey: ['id', 'version']
  });
})(DependencyWithModels || (DependencyWithModels = {}));